// Customers getters
export default {
  get_customers_list: (state) => state.items,
  get_customers_count: (state) => state.count,
  get_customer: (state) => state.customer,
};
